import { createRouter, createWebHistory } from 'vue-router'
import IndexTwo from '@/views/index/index-two.vue'
import AboutUs from '@/views/inner-pages/about-us.vue'
import FaqPage from '@/views/inner-pages/faq-page.vue'
import AiAssistant from '@/views/inner-pages/ai-assistant.vue'
import TermsAndConditions from '@/views/inner-pages/terms-and-conditions.vue'
import RequestQuotation from '@/views/inner-pages/request-quotation.vue'
import PortfolioV1 from '@/views/portfolio/portfolio-v1.vue'
import PortfolioDetailsV1 from '@/views/portfolio/portfolio-details-v1.vue'
import MyProfile from '@/views/profile/my-profile.vue'
import MyAccount from '@/views/profile/my-account.vue'
import EditAccount from '@/views/profile/edit-account.vue'
import OrderHistory from '@/views/profile/order-history.vue'
import MyRequests from '@/views/profile/my-requests.vue'
import OrderDetails from '@/views/profile/order-details.vue'
import WishlistPage from '@/views/profile/wishlist-page.vue'
import LoginPage from '@/views/auth/login-page.vue'
import RegisterPage from '@/views/auth/register-page.vue'
import ForgerPassword from '@/views/auth/forger-password.vue'
import ResetPassword from '@/views/auth/reset-password.vue'
import ThankYou from '@/views/special/thank-you.vue'
import ErrorPage from '@/views/special/error-page.vue'
import ShopV2 from '@/views/shop/shop-v2.vue'
import ProductDetails from '@/views/shop/product-details.vue'
import ShopCart from '@/views/shop/shop-cart.vue'
import CheckoutPage from '@/views/shop/checkout-page.vue'
import ContactPage from '@/views/inner-pages/contact-page.vue'
import { useClientSession } from '@/composables/use-client-session'
import { applyRouteSeo } from '@/lib/seo'

const routes = [
  { path: '/', component: IndexTwo },
  { path: '/index-v2', component: IndexTwo },
  { path: '/about', component: AboutUs },
  // The template's client-logo page showed invented companies. Until there is a
  // real one, it leads to the work we have actually done.
  { path: '/our-clients', redirect: '/portfolio-v1' },
  { path: '/faq', component: FaqPage },
  { path: '/assistant', component: AiAssistant },
  { path: '/room-match', redirect: '/assistant' },
  { path: '/terms-and-conditions', component: TermsAndConditions },
  { path: '/request-quotation', component: RequestQuotation },
  { path: '/portfolio-v1', component: PortfolioV1 },
  { path: '/portfolio-details-v1', redirect: '/portfolio-v1' },
  { path: '/portfolio-details-v1/:id', component: PortfolioDetailsV1 },
  { path: '/my-profile', component: MyProfile, meta: { requiresAuth: true } },
  { path: '/my-account', component: MyAccount, meta: { requiresAuth: true } },
  { path: '/edit-account', component: EditAccount, meta: { requiresAuth: true } },
  { path: '/order-history', component: OrderHistory, meta: { requiresAuth: true } },
  { path: '/my-requests', component: MyRequests, meta: { requiresAuth: true } },
  { path: '/order-history/:id', component: OrderDetails, meta: { requiresAuth: true } },
  { path: '/wishlist', component: WishlistPage, meta: { requiresAuth: true } },
  { path: '/login', component: LoginPage, meta: { guestOnly: true } },
  { path: '/register', component: RegisterPage, meta: { guestOnly: true } },
  { path: '/forger-password', component: ForgerPassword, meta: { guestOnly: true } },
  { path: '/forgot-password', redirect: '/forger-password' },
  { path: '/reset-password', component: ResetPassword },
  { path: '/thank-you', component: ThankYou },
  { path: '/product-category', redirect: '/shop-v2' },
  { path: '/shop-v1', redirect: '/shop-v2' },
  { path: '/shop-v2', component: ShopV2 },
  { path: '/shop-v3', redirect: '/shop-v2' },
  { path: '/shop-v4', redirect: '/shop-v2' },
  { path: '/product-details', redirect: '/shop-v2' },
  { path: '/product-details/:id', component: ProductDetails },
  { path: '/cart', component: ShopCart },
  { path: '/checkout', component: CheckoutPage },
  { path: '/contact', component: ContactPage },
  { path: '/error', component: ErrorPage },
  { path: '/:pathMatch(.*)*', component: ErrorPage },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

// afterEach, not beforeEach: a guard that redirects (an auth-only page while signed
// out) must not leave the tab titled with the page the visitor never reached.
router.afterEach((to) => {
  applyRouteSeo(to)
})

router.beforeEach(async (to) => {
  const session = useClientSession()

  try {
    await session.initializeSession()
  } catch (error) {
    // Token cleanup happens inside the session composable.
  }

  if (to.meta.requiresAuth && !session.isAuthenticated.value) {
    return {
      path: '/login',
      query: { redirect: to.fullPath },
    }
  }

  if (to.meta.guestOnly && session.isAuthenticated.value) {
    return '/my-profile'
  }

  return true
})

export default router
